export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
}

export interface MessageImage {
  url: string;
  width?: number;
  height?: number;
}

export interface Message {
  id: string;
  sessionId: string;
  role: MessageRole;
  content: string;
  images?: MessageImage[];
  createdAt: string;
}

export interface Session {
  id: string;
  uid: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssistantState {
  sessions: Session[];
  currentSessionId: string | null;
  messages: Message[];
  isLoading: boolean;
  isTyping: boolean;
  error: string | null;
}
